//
// JForm.js
//

class JForm {
    constructor() {
    }

    get element() {
        return this._element;
    }

    set element(element) {
        this._element = element;
    }

    get formValidation() {
        return this._fv;
    }

    set formValidation(fv) {
        this._fv = fv;
        this._element = fv.form;
    }

    clearResponse() {
        for (const response of this._element.querySelectorAll('.form-response')) {
            response.innerHTML = '';
        }
    }

    disabled() {
        for (const fieldset of this._element.querySelectorAll('fieldset')) {
            fieldset.disabled = true;
        }
    }

    enabled() {
        for (const fieldset of this._element.querySelectorAll('fieldset')) {
            fieldset.disabled = false;
        }
    }

    validation(data) {
        const validators = data?.JTurn?.JForm?.validators ?? {};

        for (const type in validators) {
            for (const field in validators[type]) {
                this._fv
                    .updateValidatorOption(field, 'blank', 'message', validators[type][field])
                    .updateFieldStatus(field, type.charAt(0).toUpperCase() + type.slice(1), 'blank');
            }
        }
    }

    behaviors(data) {
        const behaviors = data?.JTurn?.JForm?.behaviors ?? [];

        if (!behaviors.includes('keepFormDisabled')) {
            this.enabled();
        }

        if (behaviors.includes('reset')) {
            this._element.reset();
        }
    }
}

// Make available globally
window.JForm = JForm;